import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Avatar, Badge } from 'mw-style-react';
import cn from 'classnames';
import ActorStatusIcon from '../ActorStatusIcon';
import ActorColors from '../ActorColors';
import './ActorAvatar.scss';

/**
 * Аватар актора со статусами
 * @returns {*}
 * @constructor
 */
function ActorAvatar(props) {
  const {
    size = 'medium',
    pictureUrl,
    colorFilled,
    color,
    colors = [],
    accessDenied,
    layerStarred,
    status,
    isEvent = false,
  } = props;
  const bgColor = color || '#ffffff';
  const borderColor = color || '#DEE3E8';

  return (
    <div
      styleName={cn('aa__wrap', size)}
      style={{
        borderColor: colorFilled && !pictureUrl ? borderColor : null,
      }}
    >
      {accessDenied ? (
        <Avatar styleName="aa accessDenied" size={size}>
          <Icon type="no_eye" />
        </Avatar>
      ) : (
        <Avatar
          styleName="aa default"
          size={size}
          className="avatar"
          src={pictureUrl}
          bgColor={colorFilled && !pictureUrl ? bgColor : null}
        >
          {(!colorFilled && !pictureUrl) || isEvent ? (
            <Icon size={size} type={isEvent ? 'event' : 'actor'} />
          ) : null}
        </Avatar>
      )}
      <ActorStatusIcon size="small" status={status} />
      <div styleName="aa__colors">
        <ActorColors colors={colors} />
      </div>
      {layerStarred ? (
        <Badge styleName="aa__flag" bgColor="#E63C3C" borderColor="#ffffff" />
      ) : null}
    </div>
  );
}

ActorAvatar.propTypes = {
  size: PropTypes.oneOf(['small', 'medium']),
  pictureUrl: PropTypes.string,
  colors: PropTypes.array,
  colorFilled: PropTypes.bool,
  color: PropTypes.string,
  accessDenied: PropTypes.bool,
  layerStarred: PropTypes.bool,
  status: PropTypes.oneOf(['verified', 'rejected', 'pending', null]),
  isEvent: PropTypes.bool,
};

export default ActorAvatar;
